import { 
	CLOSE_ADD_SONG_TO_PLAYLIST_MODAL,
	OPEN_ADD_SONG_TO_PLAYLIST_MODAL,
	CLOSE_ADD_NEW_SONG_MODAL,
	CLOSE_COUNTRY_SONGS_MODAL,
	CLOSE_CREATE_PLAYLIST_MODAL,
	CLOSE_EDIT_SONG_MODAL,
	CLOSE_RANDOM_SONGS_LIST_MODAL,
	CLOSE_REGISTRATION_MODAL,
	CLOSE_SEARCH_SONG_MODAL,
	CLOSE_SONG_INFO_MODAL,
	CLOSE_USER_CREATED_PLAYLISTS,	
	CLOSE_USER_FAVORITE_SONGS,
	CLOSE_USER_PLAYLISTS_MODAL,
	CLOSE_USER_UPLOADED_SONGS,
	OPEN_COUNTRY_SONGS_MODAL,
	OPEN_EDIT_SONG_MODAL,
	OPEN_RANDOM_SONGS_LIST_MODAL,
	OPEN_SEARCH_SONG_MODAL,
	OPEN_SONG_INFO_MODAL,
	OPEN_USER_CREATED_PLAYLISTS,
	OPEN_USER_FAVORITE_SONGS,	
	OPEN_USER_PLAYLISTS_MODAL,
	OPEN_USER_UPLOADED_SONGS,
	SELECT_VIEW_OPTION,
	TOGGLE_ADD_NEW_SONG_MODAL,
	TOGGLE_CREATE_PLAYLIST_MODAL,
	TOGGLE_COUNTRIES_LIST_MODAL,
	TOGGLE_RANDOM_SONGS_LIST_MODAL,
	TOGGLE_USER_PLAYLISTS_MODAL
} from '../constants/modal-action-types';

export const closeUserPlaylistsModal = () => ({type: CLOSE_USER_PLAYLISTS_MODAL});
export const openUserPlaylistsModal = () => ({type: OPEN_USER_PLAYLISTS_MODAL});
export const toggleUserPlaylistsModal = () => ({type: TOGGLE_USER_PLAYLISTS_MODAL});


export const closeAddNewSongModal = () => ({ type: CLOSE_ADD_NEW_SONG_MODAL});
export const closeCountrySongsModal = () => ({type: CLOSE_COUNTRY_SONGS_MODAL});
export const closeCreatePlaylistModal = () => ({type: CLOSE_CREATE_PLAYLIST_MODAL});
export const closeEditSongModal = () => ({type:CLOSE_EDIT_SONG_MODAL});
export const closeRegistrationModal = () => ({type: CLOSE_REGISTRATION_MODAL});
export const closeSearchSongModal = () => ({type: CLOSE_SEARCH_SONG_MODAL});
export const closeUserCreatedPlaylists = () => ({type: CLOSE_USER_CREATED_PLAYLISTS});
export const closeUserFavoriteSongs = () => ({type: CLOSE_USER_FAVORITE_SONGS});
export const closeAddSongToPlaylistModal = () => ({type: CLOSE_ADD_SONG_TO_PLAYLIST_MODAL});
export const closeUserUploadedSongs = () => ({type: CLOSE_USER_UPLOADED_SONGS});

export const openCountrySongsModal = () => ({type: OPEN_COUNTRY_SONGS_MODAL});
export const openEditSongModal = () => ({type:OPEN_EDIT_SONG_MODAL});
export const openSearchSongModal = () => ({type: OPEN_SEARCH_SONG_MODAL});
export const openUserCreatedPlaylists = () => ({type: OPEN_USER_CREATED_PLAYLISTS});
export const openUserFavoriteSongs = () => ({type: OPEN_USER_FAVORITE_SONGS});
export const openAddSongToPlaylistModal = () => ({type: OPEN_ADD_SONG_TO_PLAYLIST_MODAL});
export const openUserUploadedSongs = () => ({type: OPEN_USER_UPLOADED_SONGS});

export const selectViewOption = function(payload){
	return {
		type:SELECT_VIEW_OPTION,
		payload
	}
}

export const toggleAddNewSongModal = () => ({ type: TOGGLE_ADD_NEW_SONG_MODAL});
export const toggleCountriesListModal = () => ({type: TOGGLE_COUNTRIES_LIST_MODAL});
export const toggleCreatePlaylistModal = () => ({type: TOGGLE_CREATE_PLAYLIST_MODAL});

